export const esOtraDiscapacidad = (tipo) => ['otra', 'otro', 'otras', 'otros'].includes((typeof tipo?.descripcion === 'string' ? tipo.descripcion.trim().toLowerCase() : ''));
const indicador = (valor) => (valor === null || valor === undefined ? 'Sin especificar' : valor ? 'Sí' : 'No');

export const DiscapacidadEmpleadoDetalle = ({ empleado = {} }) => {
  const tipos = (Array.isArray(empleado?.tiposDiscapacidad) ? empleado.tiposDiscapacidad : []).filter((tipo) => tipo && typeof tipo === 'object');
  const tiposDescripcion = tipos
    .map((tipo) => {
      const descripcion = tipo.descripcion ?? '';
      const observacion = esOtraDiscapacidad(tipo) && tipo.descripcionEmpleado?.trim()
        ? ' - ' + tipo.descripcionEmpleado.trim()
        : '';
      const estado = tipo.estado === false ? ' (Inactivo)' : '';
      return descripcion + observacion + estado;
    })
    .filter(Boolean)
    .join(', ');

  return (
    <section aria-label="Información familiar y discapacidad">
      <div className="row">
        <div className="col-sm-6">
          <div className="form-group">
            <label className="fw-bold">Tiene hijos</label>
            <input className="form-control" aria-label="Tiene hijos" readOnly value={indicador(empleado?.tieneHijos)} />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label className="fw-bold">Tiene discapacidad</label>
            <input className="form-control" aria-label="Tiene discapacidad" readOnly value={indicador(empleado?.tieneDiscapacidad)} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label className="fw-bold">Tipos de discapacidad</label>
            <input
              className="form-control"
              aria-label="Tipos de discapacidad"
              readOnly
              value={tiposDescripcion || 'Sin tipos de discapacidad registrados.'}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
